import { render, staticRenderFns } from "./TheHeaderDropdownNotifs.vue?vue&type=template&id=5cce2438&scoped=true"
import script from "./TheHeaderDropdownNotifs.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownNotifs.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownNotifs.vue?vue&type=style&index=0&id=5cce2438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce2438",
  null
  
)

export default component.exports